import React from 'react';
import './Footer.css';
import Gay from './GayIcon.png';
import Trans from './TransIcon.png';
import Ally from './AllyIcon.png';
import Escape from './escape.png';
import {Link} from '@reach/router';

const footer =() =>{
    return ( 
        <footer>
        <div class="footer">
            <div class="rightfooter"> 
            <a href = "https://google.com"> <img src = {Escape} alt = "Escape button" /></a>          
            </div>

            <div class="leftfooter">
            <Link to="/sexuality">  <img src={Gay} alt="Gay navigation icon"/></Link>  
            <Link to ="/gender"><img src={Trans} alt="Trans navigation icon"/></Link>
            <Link to ="/allies"><img src={Ally} alt="Ally navigation icon"/></Link>
            </div>
        </div>
        <div class="bottomnav">
            
            <ul>
                <li>
                <Link to="/sexuality">  <img src={Gay} alt="Gay navigation icon"/></Link>
                </li>
                <li>
                    <Link to ="/gender"><img src={Trans} alt="Trans navigation icon"/></Link>
                </li>
                <li>
                    <Link to ="/allies"><img src={Ally} alt="Ally navigation icon"/></Link>
                </li>
            </ul>
          

        </div>
        </footer>




    )
}

export default footer;